import { notAvailable } from 'core/common/constants';
import { normalizeError } from 'core/common/errors';
import {
  ATTRS_ANALYTICS_FLOW_NAME,
  ATTRS_ANALYTICS_FUNNEL_LOCALE,
  ATTRS_ANALYTICS_FUNNEL_NAME,
  SpanName,
} from 'core/common/observability/entities';
import { AppThunk } from 'core/common/store';
import { getUserLocation } from 'core/user/store/selectors';
import { CreateNatalChartPublicPayload } from '../../entities';
import { updateNatalChart } from './updateNatalChart';

export const createNatalChartPublic =
  ({
    dateOfBirth,
    timeOfBirth,
    cityLocation,
    cityCoordinates,
  }: CreateNatalChartPublicPayload): AppThunk =>
  async (dispatch, getState, context) => {
    const {
      loggingService,
      natalChartService,
      observabilitySystem,
      funnelSettingsService,
      errorMonitoringService,
    } = context;

    const funnelName = funnelSettingsService.getFunnelName();
    const flowName = funnelSettingsService.getFlowName();
    const funnelLocale = funnelSettingsService.getFunnelLocale();

    const userLocation = getUserLocation(getState());

    const attributes = {
      [ATTRS_ANALYTICS_FUNNEL_NAME]: funnelName,
      [ATTRS_ANALYTICS_FLOW_NAME]: flowName,
      [ATTRS_ANALYTICS_FUNNEL_LOCALE]: funnelLocale,
    };

    const natalChartSpan = observabilitySystem.startSpan(SpanName.CREATE_NATAL_CHART_PUBLIC, {
      attributes,
    });

    const dateTimeBirth = `${dateOfBirth}T${timeOfBirth}`;

    try {
      const natalChart = await natalChartService.createNatalChartPublic({
        date_birth: dateTimeBirth,
        place_birth: cityLocation,
        lat: cityCoordinates[1],
        lng: cityCoordinates[0],
      });

      dispatch(updateNatalChart(natalChart));

      natalChartSpan.succeed();
    } catch (err) {
      const error = normalizeError(err);
      loggingService.error(error);

      errorMonitoringService.captureError(error, {
        tags: {
          funnel_name: funnelName,
          get_params: location.search || notAvailable,
          error_message: error.message,
          error_reason: 'create_natal_chart_public',
          ...userLocation,
        },
      });

      natalChartSpan.fail(error);

      throw error;
    }
  };
